var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSultanciftligi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,8c1.1-.3,2.1-.9,3.1-1.5,3.1-1.9,6.2-3.6,9.4-5.4.6-.4,1.4-1,2.1-.3.7.6.4,1.5.1,2.2-.9,3.1,0,5,3.1,6.6,3.6,1.9,6.9,4.1,6.4,9.4-.2,2.2,1.8,4.8,2.8,7.2.8,2,.7,3.1-1.5,3.7-2.8.7-5.1,2.4-7.4,4.1-.6.4-1.4,1.1-2,.2-.5-.7.2-1.3.8-1.7,2.4-1.9,2.4-4.7,2.5-7.2.2-2.5-4.3-4.4-6.6-3.3-4.9,2.5-10.3,3.6-15.7,4C1.4,26.1,0,24.7,0,21.6c0-.7,0-1.3.7-1.4,3.4-.4,3.7-3.4,4.7-5.7.3-.6.4-.9.5-1.3.6-1.5,1.1-2.9,1.3-3.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSultanciftligi);
export default __webpack_public_path__ + "static/media/sultanciftligi.04b26d3765289bb22201043a03a0f49f.svg";
export { ForwardRef as ReactComponent };